document.addEventListener("alpine:init", () => {
    Alpine.data("progressiveAccordionSecondary", () => ({
        id: null,
        secondaryItems: null,
        init() {
            this.secondaryItems = this.$el.querySelectorAll(
                ".Pegasus__Container"
            );

            window.addEventListener("pegasus-pa-item-selected", (event) => {
                this.id = event.detail.id;

                this.secondaryItems.forEach((element) => {
                    if (this.id === element.id) {
                        element.style.display = "";
                    } else {
                        element.style.display = "none";
                    }
                });
            });
        },
    }));
});
